const swiper = new Swiper('.reviews__swiper', {
	loop: true,
	spaceBetween: 15,
	pagination: {
		el: '.reviews__pagination',
		clickable: true,
	}
});
